// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__Jj_dM","title":"Info_title__2QG3O","links":"Info_links__Cvnvy","link":"Info_link__2A1ed","logo":"Info_logo__3P2kg"};